import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import DemoGate from './components/DemoGate';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Mentors from './pages/Mentors';
import MentorDetail from './pages/MentorDetail';
import Masterclasses from './pages/Masterclasses';
import Opportunities from './pages/Opportunities';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Dashboard from './pages/Dashboard';
import './App.css';

function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '5rem 1rem' }}>
      <h1 style={{ fontSize: '4rem', color: '#1F2D5E', fontFamily: "'Fraunces', Georgia, serif" }}>404</h1>
      <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>Page introuvable.</p>
      <a href="/" style={{ color: '#1F2D5E', fontWeight: 700 }}>Retour à l'accueil</a>
    </div>
  );
}

export default function App() {
  return (
    <DemoGate>
      <AuthProvider>
        <BrowserRouter>
          <div className="app-layout">
            <Navbar />
            <Routes>
              <Route path="/"             element={<Home />} />
              <Route path="/mentors"      element={<Mentors />} />
              <Route path="/mentors/:id"  element={<MentorDetail />} />
              <Route path="/masterclasses" element={<Masterclasses />} />
              <Route path="/opportunites" element={<Opportunities />} />
              <Route path="/login"        element={<Login />} />
              <Route path="/inscription"  element={<Register />} />
              <Route path="/profil"       element={<Profile />} />
              <Route path="/admin/tableau-de-bord" element={<Dashboard />} />
              <Route path="*"             element={<NotFound />} />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </DemoGate>
  );
}
